import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import 'react-grid-layout/css/styles.css';
import './theme.css';

const root = document.getElementById('root');
if (root === null) throw new Error('index.html is missing #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

